import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { ObjectOfVersions } from "../../../operations/reducer"
import { EmployeeFormValues } from "./form/types"

export const EMPLOYEE_UPDATE_SUCCESS = "EMPLOYEE_UPDATE_SUCCESS"
export const employeeUpdateSuccess = (formData: EmployeeFormValues, userAccountId: Maybe<string> = null) => ({
    type: EMPLOYEE_UPDATE_SUCCESS,
    payload: {
        formData: formData,
        userAccountId: userAccountId,
    },
})

export const EMPLOYEE_CREATE_SUCCESS = "EMPLOYEE_CREATE_SUCCESS"
export const employeeCreateSuccess = (
    formData: EmployeeFormValues,
    userAccountId: string,
    accountId: string,
    userId: string
) => ({
    type: EMPLOYEE_CREATE_SUCCESS,
    payload: {
        formData: formData,
        userAccountId: userAccountId,
        userId: userId,
        accountId: accountId,
    },
})

export const EMPLOYEE_DELETE_SUCCESS = "EMPLOYEE_DELETE_SUCCESS"
export const employeeDeleteSuccess = (employeeId: string) => ({
    type: EMPLOYEE_DELETE_SUCCESS,
    payload: {
        employeeId: employeeId,
    },
})

export const CLOSE_EMPLOYEE_FORM_CLICKED = "CLOSE_EMPLOYEE_FORM_CLICKED"
export const closeEmployeeFormClicked = () => ({
    type: CLOSE_EMPLOYEE_FORM_CLICKED,
})

export const EMPLOYEES_AGENDA_MOUNTED = "EMPLOYEES_AGENDA_MOUNTED"
export const employeesAgendaMounted = () => ({
    type: EMPLOYEES_AGENDA_MOUNTED,
})

export const EMPLOYEE_REQUEST_PASSWORD_RESET = "EMPLOYEE_REQUEST_PASSWORD_RESET"
export const employeeRequestPasswordReset = (email: string) => ({
    type: EMPLOYEE_REQUEST_PASSWORD_RESET,
    payload: {
        email: email,
    },
})

export const USER_VERSION_UPDATED = "USER_VERSION_UPDATED"
export const userVersionUpdated = (versions: ObjectOfVersions) => ({
    type: USER_VERSION_UPDATED,
    payload: {
        versions: versions,
    },
})
